<template>
  <div>
    <b-breadcrumb :items="breadCrumbs" />

    <b-row v-if="orders && orders.length">
      <b-col md="6" class="my-1">
        <b-form-group horizontal label="Filter" class="mb-0">
          <b-input-group>
            <b-form-input
              v-model="filter"
              placeholder="Type to Search"
              :autofocus="true"
              @blur="trimExpiryDate"
              @change="trimExpiryDate"
              @input="trimExpiryDate"
            />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <div class="float-right" v-if="orders.length > 0">
          Total orders: {{ orders.length }}
        </div>
        <!-- <b-form-group horizontal label="Per page" class="mb-0">
					<b-form-select :options="pageOptions" v-model="perPage" />
        </b-form-group> -->
      </b-col>
    </b-row>

    <b-row class="mt-3" v-if="orders && orders.length">
      <b-col md="12">
        <b-table
          :items="orders"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          v-if="orders"
        >
          <template slot="cell(order_id)" slot-scope="row">
            {{ row.item.order_id }}
            <!-- <span v-if="row.item.payment_code === 'blockchain'">
              <br />
              <img
                style="width: 32px;height: 32px;"
                src="/assets/icons/blockchain.png"
              />
            </span> -->
            <!-- <b-badge
              class="text-center"
              variant="warning"
              v-if="!row.item.complete"
              >Partially Picked</b-badge
            > -->
          </template>
          <template slot="cell(name)" slot-scope="row">
            {{
              row.item.customer.first_name + " " + row.item.customer.last_name
            }}
          </template>
          <template slot="cell(shipping)" slot-scope="row">
            <div style="width:200px;">
              <!-- <span :class="rowClass(row.item.shipping_method)">
                {{ row.item.shipping_method }}
              </span> -->
              <span>Shipping Method HERE</span>
            </div>
          </template>
          <template slot="cell(line_items)" slot-scope="row">
            <ul>
              <li :key="index" v-for="(item, index) in row.item.line_items">
                {{
                  item.quantity +
                    " X " +
                    item.sku +
                    " (" +
                    item.variant_title +
                    ")"
                }}
              </li>
            </ul>
          </template>
          <template slot="cell(actions)" slot-scope="row">
            <div style="width:150px;">
              <b-button
                size="sm"
                variant="warning"
                class="ml-2"
                :to="'/order/' + row.item.id + '/pick'"
                >Pick</b-button
              >
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row v-if="orders && orders.length">
      <b-col md="6" class="my-1">
        <b-pagination
          :total-rows="orders.length"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
        />
      </b-col>
    </b-row>

    <b-row v-if="!orders || orders.length == 0">
      <b-col md="6" class="my-1 offset-md-3">
        <b-alert show variant="success">No Orders to pick. Yay!</b-alert>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "shopify-orders",
  components: {},
  data() {
    return {
      orders: null,
      fields: [
        { key: "id", label: "#", sortable: true },
        { key: "created_at", label: "Date" },
        { key: "name", label: "Name" },
        { key: "line_items", label: "Items" },
        { key: "shipping", label: "Shipping", class: "text-center" },
        // {
        //   key: "brand",
        //   label: "Brand",
        //   class: "text-center",
        //   tdClass: this.BRAND !== "EB" ? "d-none" : "",
        //   thClass: this.BRAND !== "EB" ? "d-none" : ""
        // },
        { key: "actions", label: "" }
      ],
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Orders", active: true }
      ],
      currentPage: 1,
      perPage: 50,
      pageOptions: [10, 25, 50],
      filter: null
    };
  },
  mounted: function() {
    this.listOrders();
  },
  methods: {
    trimExpiryDate() {
      const filter = this.filter;
      var matches = filter.match(/-[0-9]{6}/);
      if (matches) {
        this.filter = filter.split(matches[0])[0];
      }
    },
    listOrders: function() {
      let loader = this.$loading.show();
      this.$http.get(this.APIURL + this.BRAND + "/order").then(
        response => {
          this.orders = response.data.filter(
            order => order.db_order_status_id === 1
          );
          loader.hide();
        },
        error => {
          loader.hide();
          console.log(error);
        }
      );
    },
    rowClass: function(shippingMethod) {
      return "";
      // if (this.BRAND == "IM") {
      //   return shippingMethod.toLowerCase().includes("ups")
      //     ? "bg-danger text-white shipping-red"
      //     : "";
      // } else {
      //   return shippingMethod.toLowerCase().includes("express")
      //     ? "bg-danger text-white shipping-red"
      //     : "";
      // }
    }
  }
};
</script>
